import React from "react";
import { Card } from "../types";

type CardGridProps = {
  cards: Card[];
  getBinderName?: (binderId: string) => string | null;
  onCardClick?: (card: Card) => void;
  readOnly?: boolean;
  onRemoveCard?: (cardId: string) => void;
};

const CardGrid: React.FC<CardGridProps> = ({
  cards,
  getBinderName,
  onCardClick,
  readOnly,
  onRemoveCard,
}) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
    {cards.map(card => (
      <div
        key={card.id}
        className="bg-white rounded-xl shadow-md p-4 flex flex-col items-center relative border border-gray-100 hover:shadow-lg transition-all duration-200 cursor-pointer"
        onClick={() => onCardClick && onCardClick(card)}
      >
        {/* Assigned badge */}
        {card.assignedBinderId && (
          <span className="absolute top-2 left-2 bg-indigo-500 text-white text-xs px-2 py-1 rounded shadow z-10">
            In Binder{getBinderName ? `: ${getBinderName(card.assignedBinderId) || "Unknown"}` : ""}
          </span>
        )}
        {/* Remove card button (only if not readOnly) */}
        {!readOnly && onRemoveCard && (
          <button
            className="absolute top-2 right-2 text-red-400 hover:text-red-600 text-xl w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 shadow transition"
            onClick={e => {
              e.stopPropagation();
              onRemoveCard(card.id);
            }}
            title="Remove Card"
          >
            ×
          </button>
        )}
        {card.image && (
          <img src={card.image} alt={card.name} className="w-16 h-24 object-contain mb-2 rounded" />
        )}
        <div className="font-bold text-indigo-700 text-center">{card.name}</div>
        <div className="text-xs text-gray-500">{card.set}</div>
        <div className="text-xs text-gray-500">#{card.number}</div>
        <div className="text-xs text-gray-500">{card.rarity}</div>
      </div>
    ))}
  </div>
);

export default CardGrid;